import { css } from '@microsoft/fast-element';
export const foundationFileUploadStyles = css `
  /* Host */
  :host {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  .file-selection {
    display: flex;
    align-items: end;
    justify-content: start;
    padding-bottom: 10px;
  }

  .file-selection :nth-last-child(-n + 2) {
    margin: 0;
    margin-left: 10px;
  }

  input[type='file'] {
    display: none;
  }

  .clear-icon {
    cursor: pointer;
  }

  .uploader-grid {
    overflow-y: auto;
  }

  .file-name-input {
    flex: 1;
  }

  .download-button-container {
    display: flex;
  }

  .download-button {
    height: 22px;
  }

  fast-data-grid-row {
    align-items: center;
  }
`;
